export default (theme) => {
  return {
    container: {
      position: 'relative',
    },
  }
}
